<script setup>
import { PALETTE_ITEMS } from '../constants';

const onDragStart = (event, nodeType) => {
  event.dataTransfer.setData('application/vueflow', nodeType);
  event.dataTransfer.effectAllowed = 'move';
};
</script>

<template>
  <div class="flex flex-col gap-2 p-3 w-56 shrink-0 overflow-y-auto border-r border-n-weak">
    <p class="mb-1 text-xs font-semibold uppercase text-n-slate-10">
      {{ $t('BOT_FLOWS.EDITOR.PALETTE_TITLE') }}
    </p>
    <div
      v-for="item in PALETTE_ITEMS"
      :key="item.type"
      class="flex items-center gap-2 px-3 py-2 text-sm rounded-lg cursor-grab bg-n-solid-2 hover:bg-n-solid-3 active:cursor-grabbing"
      draggable="true"
      @dragstart="onDragStart($event, item.type)"
    >
      <span
        class="grid rounded size-6 place-content-center text-white text-xs shrink-0"
        :style="{ backgroundColor: item.color }"
      >
        <span :class="item.icon" />
      </span>
      <span class="truncate text-n-slate-12">{{ item.label }}</span>
    </div>
    <p class="mt-2 text-[11px] text-n-slate-10">
      {{ $t('BOT_FLOWS.EDITOR.PALETTE_HELP') }}
    </p>
  </div>
</template>
